import { ThemeProvider } from '@creditas-ui/system';
import { standard } from '@creditas-ui/themes';
import { MobileBar } from '@/mobilebar';
import { Sidebar, useSidebar } from '@/sidebar';
import { useFlags, useProfile } from '@/sidebar/application/hooks';
import { items, flagItems } from '@/shared/presentation';
import { isMobile } from './shared/helpers/deviceDetect';

const App = (): JSX.Element => {
  const { isDashboardEnabled } = useFlags();
  const {
    expanded,
    expandedProfile,
    expandedResponsible,
    setExpandedProfile,
    setExpandedResponsible,
    mouseLeave,
    mouseEnter,
  } = useSidebar();
  const userProfile = useProfile();

  const profile = {
    ...userProfile,
    toggle: expandedProfile,
    setToggle: setExpandedProfile,
    toggleResponsible: expandedResponsible,
    setToggleProfile: setExpandedResponsible,
    setToggleResponsible: setExpandedResponsible,
  };

  const resolveNaviItems = () =>
    isDashboardEnabled ? [...items, ...flagItems] : items;

  return (
    <ThemeProvider theme={standard}>
      {isMobile() ? (
        <MobileBar items={resolveNaviItems()} />
      ) : (
        <Sidebar
          items={resolveNaviItems()}
          profile={profile}
          expanded={expanded}
          onMouseEnter={mouseEnter}
          onMouseLeave={mouseLeave}
        />
      )}
    </ThemeProvider>
  );
};

export default App;
